import { styled } from '@material-ui/core/styles'

export const ItemWrap = styled('div')({
  display: 'flex',
  ['&:not(:first-of-type)']: {
    marginTop: '8px',
  },
  ['&:not(:last-of-type)']: {
    marginBottom: '8px',
  },
})
